<template>
    <div>
        <div class="object-titlebox">
            <div v-if="isRootNode">
                <div class="object-titlebox-left" style="float:clear">
                    <span v-t="'message.title_user_publish_information1'"></span>
                    <el-tooltip effect="light" placement="top-start">
                        <div slot="content" style="text-align:left"  v-t="'message.hint_location_appended_data'"></div>
                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                    </el-tooltip>
                </div>
            </div>
            <div v-else>
                <table width="100%">
                    <tr>
                        <td class="object-titlebox-left" style="float:clear">
                            <span v-t="{ path: 'message.title_user_publish_information2', args: { information: selectedNode.data.label } }"></span>
                            <el-tooltip effect="light" placement="top-start">
                                <div slot="content" style="text-align:left" v-html="selectedNode.data.hint"></div>
                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                            </el-tooltip>
                        </td>
                        <td style="text-align:right;padding-right:20px">
                            <div v-if="publishUserList.length == 0">
                                <button class="transparent" type="button" v-on:click="showEditUserPublishInformation=true"><img src="../../../../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.action_add_publish_information_to_user'"></span></button>
                            </div>
                            <div v-else>
                                <button class="transparent" type="button" v-on:click="showEditUserPublishInformation=true"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.action_edit_publish_information_to_user'"></span></button>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div v-if="isRootNode">
            <div class="object-inner-table">
                <table width=100%>
                    <tr width="100%" class="no-data-message">
                        <td style="display: inline-block" v-t="'message.info_select_user_publish_information'">
                        </td>
                    </tr>
                    <tr width="100%">
                        <td style="color:#d55169;text-align:center;padding-top:20px" v-html="$t('message.info_location_appended_data_notice')">
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div v-else>
            <div class="object-titlebox">
                <div class="object-titlebox-left">
                    <el-form @submit.native.prevent="submit">
                        <el-input :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchKeyword" class="input-with-select" clearable  @clear="getInfo(0)" :disabled="userSearchDisabled" >
                            <el-select v-model="condition" slot="prepend" :placeholder="$t('message.place_holder_search_condition')">
                                <el-option :label="$t('message.item_userId')" value="name"></el-option>
                                <el-option :label="$t('message.item_userDisplayName')" value="displayName"></el-option>
                                <el-option :label="$t('message.item_organization')" value="organization"></el-option>
                                <el-option :label="$t('message.item_job_title')" value="title"></el-option>
                            </el-select>
                            <el-button slot="append" @click="getInfo(1)" style="width: 100px; vertical-align: middle;" native-type="submit" v-t="'message.action_filter_items'"></el-button>
                        </el-input>
                    </el-form>
                </div>
            </div>
            <div class="object-inner-table">
                <table width=100%>
                    <tr class="item-list-title">
                        <td width=50% class="object-item">
                            <div class="object-userlist-left">
                                <div class="object-userlist-right">
                                    <span class="item-list-header" v-t="'message.common_action_delete'"></span>
                                </div>
                                <span class="item-list-header" v-t="'message.item_userId_displayName'"></span>
                            </div>
                        </td>
                    </tr>
                    <tr width="100%" v-if="publishUserList.length == 0" class="no-data-message">
                        <div v-if="searchKeyword == null">
                            <td style="display: inline-block" v-t="{ path: 'message.info_user_not_found_with_publish_information', args: { information: selectedNode.data.label } }"></td>
                        </div>
                        <div v-else>
                            <td style="display: inline-block" v-t="'message.info_user_not_found'"></td>
                        </div>
                    </tr>
                    <tr v-for="(publishUser,index) in publishUserList" class="record-with-underline">
                        <td width=50% class="object-item">
                            <div class="object-userlist-left">
                                <div class="object-userlist-right">
                                    <button class="item-record-button" type="button" v-on:click="removePublishUserConfirm(index)"><img class="icon-delete" src="../../../../assets/icon_delete_user.svg" /></button>
                                </div>
                                {{ getUserDisplayName(publishUser) }}
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <editpublishinformation v-if="showEditUserPublishInformation" :appData="appData" :informationType="selectedNode.data.settingName" :editUserList="getPublishUserList(selectedNode.data.settingName)" @save="saveUserPublishInformation" @cancel="showEditUserPublishInformation=false"></editpublishinformation>
        <confirmdeleteuser v-if="showConfirmDeleteUser" :confirmInfo="confirmInfo" @delete="removeInformation" @cancel="showConfirmDeleteUser=false"></confirmdeleteuser>
    </div>
</template>

<script>
import Vue from 'vue'
import server from "../../../ServerApi.js";
import EditPublishInformation from "../../../EditPublishInformation.vue";
import DeleteObject from "../../../DeleteObject.vue";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';

export default {
    data() {
      return {
            condition: "name",
            isRootNode: false,
            searchKeyword: null,
            showEditUserPublishInformation: false,
            showConfirmDeleteUser: false,
            userSearchDisabled: true,
            publishUserList: [],
            publishAccuracyUserList: [],
            publishSpeedUserList: [],
            publishDirectionUserList: [],
            publishBatteryUserList: [],
            confirmInfo: {
                objectName: null,
                objectTitle: null
            },
      };
    },
    methods: {
        getInfo(getType) {
            let self = this;

            this.isRootNode = (this.selectedNode.data.type == constants.SETTING_USER_PUBLISH_INFORMATION_ROOT);

            let param = { tenantId: this.appData.tenantList[0].tenantId, publishInformations: 1}
            if (getType == 0) {
                this.searchKeyword = null;
            } else {
                if (this.condition == "name") {
                    param.name = this.searchKeyword;
                } else if (this.condition == "displayName") {
                    param.displayName = this.searchKeyword;
                } else if (this.condition == "organization") {
                    param.organization = this.searchKeyword;
                } else if (this.condition == "title") {
                    param.title = this.searchKeyword;
                } else {
                    commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_search_condition_not_found"));
                    return;
                }
            }

            server.post('/finduser', param)
            .then((res) => {
                self.publishAccuracyUserList = [];
                self.publishSpeedUserList = [];
                self.publishDirectionUserList = [];
                self.publishBatteryUserList = [];
                switch(res.data.status) {
                    case 0:
                        for (let user of res.data.userInfo) {
                            if (commonUtil.checkUserPublishInformation(user.publishInformations, constants.USER_PUBLISH_INFORMATION_ACCURACY)) {
                                self.publishAccuracyUserList.push(user);
                            }
                            if (commonUtil.checkUserPublishInformation(user.publishInformations, constants.USER_PUBLISH_INFORMATION_SPEED)) {
                                self.publishSpeedUserList.push(user);
                            }
                            if (commonUtil.checkUserPublishInformation(user.publishInformations, constants.USER_PUBLISH_INFORMATION_DIRECTION)) {
                                self.publishDirectionUserList.push(user);
                            }
                            if (commonUtil.checkUserPublishInformation(user.publishInformations, constants.USER_PUBLISH_INFORMATION_BATTERY)) {
                                self.publishBatteryUserList.push(user);
                            }
                        }
                        break;
                    case -3:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getInfo").replace("{code}",res.data.status));
                        break;
                }
                self.refreshUserList();
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getInfo", error);
            });
        },
        saveUserPublishInformation(input) {
            this.showEditUserPublishInformation=false;
            let targetUserList;
            let informationName = this.selectedNode.data.settingName;
            switch(informationName) {
                case constants.USER_PUBLISH_INFORMATION_ACCURACY:
                    targetUserList = this.publishAccuracyUserList;
                    break;
                case constants.USER_PUBLISH_INFORMATION_SPEED:
                    targetUserList = this.publishSpeedUserList;
                    break;
                case constants.USER_PUBLISH_INFORMATION_DIRECTION:
                    targetUserList = this.publishDirectionUserList;
                    break;
                case constants.USER_PUBLISH_INFORMATION_BATTERY:
                    targetUserList = this.publishBatteryUserList;
                    break;
            }

            let modifiedUserList = [];
            for (let userInfo of targetUserList) {
                modifiedUserList.push(userInfo);
            }

            let operations = [];
            for (let key in input.addTagList) {
                let tag = input.addTagList[key]
                if (tag.orgPublishInformations == null) {
                    tag.orgPublishInformations = "";
                }
                if (tag.orgPublishInformations.indexOf(informationName) == -1) {
                    let newPublishInformations;
                    if (tag.orgPublishInformations != "") {
                        newPublishInformations = tag.orgPublishInformations + "," + informationName;
                    } else {
                        newPublishInformations = informationName;
                    }
                    operations.push({
                        command: "modifyuser",
                        operation: {
                            tenantId: tag.tenantId,
                            name: tag.userName,
                            newPublishInformations: newPublishInformations,
                        }
                    })
                    modifiedUserList.push({
                       id: tag.userName,
                       name: tag.userName,
                       displayName: tag.displayName,
                       publishInformations: newPublishInformations
                   })
                }
            }

            for (let key in input.removeTagList) {
                let tag = input.removeTagList[key]
                if (tag.orgPublishInformations == null) {
                    continue;
                }
                if (tag.orgPublishInformations.indexOf(informationName) >=0) {
                    let publishInformations = tag.orgPublishInformations.split(",");
                    let newPublishInformations = "";
                    for (let publishInformation of publishInformations) {
                    	if (publishInformation != informationName) {
                    		if (newPublishInformations != "") {
                    			newPublishInformations += ",";
                    		}
                    		newPublishInformations += publishInformation;
                    	}
                    }
                    operations.push({
                        command: "modifyuser",
                        operation: {
                            tenantId: tag.tenantId,
                            name: tag.userName,
                            newPublishInformations: newPublishInformations,
                        }
                    })
                    for (let i=0 ; i < modifiedUserList.length ; i++) {
                        if (modifiedUserList[i].name == tag.userName) {
                            modifiedUserList.splice(i,1);
                        }
                    }
                }
            }

            if (operations.length == 0) {
                return;
            }

            const loading = this.$loading({
                    lock: true ,
                    text: 'Updateing  Client restrictions ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });
            let timer = setTimeout(() => {
                      loading.close();
                      commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"info_need_time_until_finish"));
                    }, 5000);

            let self = this;
            server.post('/multiop', {operations: operations})
                .then((res) => {
                    clearTimeout(timer);
                    loading.close();
                    switch(res.data.status) {
                        case 0:
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_user_publish_informations").replace("{information}",commonUtil.getUserPublishInformationName(this.$i18n,this.selectedNode.data.settingName)));
                            this.refreshUserList();
                            this.getInfo(0);
                            break;
                        case -6:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_publish_information_by_denied"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","saveUserPublishInformation").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "saveUserPublishInformation", error);
                });
        },
        removePublishUserConfirm(index) {
            this.removePublishInformationIndex = index;
            switch(this.selectedNode.data.settingName) {
                case constants.USER_PUBLISH_INFORMATION_ACCURACY:
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_publish_informations_setting2").replace("{information}",commonUtil.getMessageText(this.$i18n,"item_accuracy"));
                    break;
                case constants.USER_PUBLISH_INFORMATION_SPEED:
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_publish_informations_setting2").replace("{information}",commonUtil.getMessageText(this.$i18n,"item_speed"));
                    break;
                case constants.USER_PUBLISH_INFORMATION_DIRECTION:
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_publish_informations_setting2").replace("{information}",commonUtil.getMessageText(this.$i18n,"item_direction"));
                    break;
                case constants.USER_PUBLISH_INFORMATION_BATTERY:
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_publish_informations_setting2").replace("{information}",commonUtil.getMessageText(this.$i18n,"item_battery"));
                    break;
            }
            this.confirmInfo.objectName = this.publishUserList[this.removePublishInformationIndex].displayName;
            this.showConfirmDeleteUser = true;
        },
        removeInformation() {
            this.showConfirmDeleteUser = false;
            let self = this;
            let newPublishInformations = "";
            if (this.publishUserList[this.removePublishInformationIndex].publishInformations.indexOf(this.selectedNode.data.settingName) >=0) {
                let publishInformations = this.publishUserList[this.removePublishInformationIndex].publishInformations.split(",");
                for (let publishInformation of publishInformations) {
                    if (publishInformation != this.selectedNode.data.settingName) {
                        if (newPublishInformations != "") {
                            newPublishInformations += ",";
                        }
                        newPublishInformations += publishInformation ;
                    }
                }
            } else {
                return;
            }

            server.post('/modifyuser', {
                    operation: {
                        tenantId: this.appData.tenantList[0].tenantId,
                        name: this.publishUserList[this.removePublishInformationIndex].name,
                        newPublishInformations: newPublishInformations
                    }
                })
                .then((res) => {
                    switch(res.data.status) {
                        case 0:
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_delete_publish_information_from_user").replace("{information}",commonUtil.getUserPublishInformationName(this.$i18n, this.selectedNode.data.settingName)));
                            self.getInfo(0);
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","removeInformation").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "removeInformation", error);
                });
        },
        getPublishUserList(privilege) {
            switch(privilege) {
                case constants.USER_PUBLISH_INFORMATION_ACCURACY:
                    return this.publishAccuracyUserList;
                case constants.USER_PUBLISH_INFORMATION_SPEED:
                    return this.publishSpeedUserList;
                case constants.USER_PUBLISH_INFORMATION_DIRECTION:
                    return this.publishDirectionUserList;
                case constants.USER_PUBLISH_INFORMATION_BATTERY:
                    return this.publishBatteryUserList;
            }
        },
        getUserDisplayName(userInfo) {
            return userInfo.name + "@" +  this.appData.tenantList[0].name + " / " + userInfo.displayName;
        },
        refreshUserList() {
            switch(this.selectedNode.data.settingName) {
                case constants.USER_PUBLISH_INFORMATION_ACCURACY:
                    this.publishUserList = this.publishAccuracyUserList;
                    break;
                case constants.USER_PUBLISH_INFORMATION_SPEED:
                    this.publishUserList = this.publishSpeedUserList;
                    break;
                case constants.USER_PUBLISH_INFORMATION_DIRECTION:
                    this.publishUserList = this.publishDirectionUserList;
                    break;
                case constants.USER_PUBLISH_INFORMATION_BATTERY:
                    this.publishUserList = this.publishBatteryUserList;
                    break;
            }
            if (this.searchKeyword == null) {
                if (this.publishUserList.length == 0) {
                    this.userSearchDisabled = true;
                } else {
                    this.userSearchDisabled = false;
                }
            }
        }
    },
    components: {
        editpublishinformation: EditPublishInformation,
        confirmdeleteuser: DeleteObject,
    },
    created: function() {
        if (this.appData.tenantList.length > 0) {
            return this.getInfo(0);
        }
    },
    mounted: function() {
    },
    watch: {
        'appData.tenantList'(newVal) {
            this.getInfo(0);
        },
        'selectedNode'(newVal) {
            this.getInfo(0);
        }
    },
    props: [ 'appData' , 'selectedNode' ]
}

</script scoped>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.record-with-underline {
    border-bottom:1px #eee solid;
}

.input-with-select {
    width: 400px;
}
.input-with-select >>> .el-input-group__prepend {
    background-color: #fff;
}
.input-with-select >>> .el-select .el-input {
    font-size: 14px;
    width: 120px;
}
.input-with-select >>> .el-button {
    width: 40px;
    padding: 0;
}
.input-with-select >>> .el-input__inner {
    font-size: 14px;
    padding-left: 10px;
}
.el-select >>> .el-input__inner {
    font-size: 14px;
    padding-left: 10px;
}
.el-select-dropdown__item {
    font-size: 14px;
}

</style>
